import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const EmailRenderer = (props) => {
  return (
    <Link to={`mailto:${props.value}`}>{props.value}</Link>
  );
};

EmailRenderer.propTypes = {
  value: PropTypes.string
};


export default EmailRenderer;
